module.exports = __webpack_public_path__ + "img/10_32.1ee4bcaf.png";